import { useEffect, useState } from "react";

// The farm "grows" while you wait: egg → chicken → goat → cow → buffalo.
const STAGES = [
  { emoji: "🥚", label: "Egg" },
  { emoji: "🐔", label: "Chicken" },
  { emoji: "🐐", label: "Goat" },
  { emoji: "🐄", label: "Cow" },
  { emoji: "🐃", label: "Buffalo" },
];

const STEP_MS = 500;

function useFarmStage(active) {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (!active) return undefined;
    setI(0);
    const t = setInterval(() => setI((n) => (n + 1) % STAGES.length), STEP_MS);
    return () => clearInterval(t);
  }, [active]);
  return i;
}

/** Inline loader — drop in place of "Loading…" text. */
export function FarmLoader({ message = "Loading…", size = "md" }) {
  const i = useFarmStage(true);
  return (
    <div className={`farm-loader farm-loader--${size}`} role="status" aria-live="polite">
      <div className="farm-loader__track">
        {STAGES.map((s, idx) => (
          <span
            key={s.label}
            className={`farm-loader__emoji ${idx === i ? "is-on" : ""} ${idx < i ? "is-done" : ""}`}
            aria-hidden="true"
          >
            {s.emoji}
          </span>
        ))}
      </div>
      {message && <p className="farm-loader__msg">{message}</p>}
      <span className="sr-only">{message}</span>
    </div>
  );
}

/** Full-screen overlay loader — show while an action is in flight. */
export function FarmLoaderOverlay({ show, message = "Just a moment…" }) {
  const i = useFarmStage(show);
  if (!show) return null;
  const stage = STAGES[i];
  return (
    <div className="farm-overlay" role="alertdialog" aria-busy="true" aria-live="assertive">
      <div className="farm-overlay__pill">
        <span className="farm-overlay__emoji" key={stage.label} aria-hidden="true">{stage.emoji}</span>
        <span className="farm-overlay__msg">{message}</span>
      </div>
    </div>
  );
}

export default FarmLoader;
